import type { ReturnRequestStatusDto } from "@babackapp/private-api-client/types";

// BAB-3194 — a refusal writes `approved: { done: true, status: 'rejected' }`, so
// `approved.done` alone cannot gate the post-approval actions.
export function isReturnRequestApproved(statuses: ReturnRequestStatusDto) {
  return statuses.approved.done && statuses.approved.status !== "rejected";
}
